<template>
  <v-container fluid class="fill-height d-block">
    <div class="pa-2 fill-height d-flex flex-column">
      <div class="users-searches">
        <v-form
          @submit.prevent="filtersSubmission()"
          class="d-flex align-center mb-3 flex-column flex-sm-row justify-sm-space-between"
        >
          <v-autocomplete
            v-model="filtersObj.userId"
            :items="usernamesList.allItems"
            item-value="id"
            item-text="username"
            prepend-inner-icon="mdi-magnify"
            :label="$t('panel.usersPage.searchBoxesForm.userName')"
            class="theme-custom-input input-search user-name"
            outlined
            hide-details
            clearable
            dense
            :loading="usernamesList.autocompleteListLoading"
            @focus="
              inputSearchCheck($event, service, 'usernamesList', 'username')
            "
            @keyup="inputSearch($event, service, 'usernamesList', 'username')"
            @paste="inputSearch($event, service, 'usernamesList', 'username')"
            @click:clear="
              inputSearch($event, service, 'usernamesList', 'username')
            "
          >
            <template v-slot:append-item>
              <div
                v-intersect.quiet="intersectUsernameList"
                class="ms-4"
                v-if="
                  !usernamesList.moreItemsLoading &&
                    usernamesList.displayMoreItem
                "
              >
                ...
              </div>
              <v-progress-circular
                v-else-if="usernamesList.moreItemsLoading"
                :size="20"
                :width="2"
                color="primary"
                indeterminate
                class="d-block mx-auto"
              />
            </template>
          </v-autocomplete>
          <div
            class="d-flex flex-sm-wrap justify-space-around align-center align-content-center align-self-sm-end form-buttons"
          >
            <v-btn depressed color="primary" class="ma-3" type="submit">
              {{ $t("panel.usersPage.searchBoxesForm.submit") }}
            </v-btn>
            <v-btn outlined color="primary" @click="resetFilters">{{
              $t("panel.usersPage.searchBoxesForm.reset")
            }}</v-btn>
          </div>
        </v-form>
      </div>
      <v-data-table
        fixed-header
        :headers="$t('panel.usersPage.table.header')"
        :items="tableData"
        item-key="id"
        :loading="loading"
        loading-text="Loading... Please wait"
        :page.sync="filtersObj.page"
        :items-per-page="filtersObj.size"
        hide-default-footer
        @page-count="pageCount = $event"
        :class="shortList"
      >
        <template v-slot:item.action="{ item }">
          <router-link
            v-if="item.userStatus !== 'UNVERIFIED'"
            :to="{
              name: 'usersDetails',
              params: { userId: item.id }
            }"
          >
            {{ $t("panel.usersPage.table.content.action") }}
          </router-link>
        </template>
        <template v-slot:item.registerDate="{ item }">
          <div class="text-no-wrap">{{ item.registerDate | $renderDate }}</div>
        </template>
        <template v-slot:item.lastUpdate="{ item }">
          <div class="text-no-wrap">{{ item.lastUpdate | $renderDate }}</div>
        </template>
        <template v-slot:item.username="{ item }">
          <router-link
            :to="{
              name: 'businessesList',
              query: { userId: item.id }
            }"
            >{{ item.username }}</router-link
          >
        </template>
        <template v-slot:item.name="{ item }">
          {{ item.firstName }} {{ item.lastName }}
        </template>
      </v-data-table>

      <div v-if="tableData.length" class="text-center pt-2">
        <v-pagination
          v-model="filtersObj.page"
          :length="totalPages"
          :total-visible="7"
          prev-icon="< Back"
          next-icon="Next >"
          class="pagination"
          @input="filtersSubmission(true)"
        ></v-pagination>
      </div>
    </div>
  </v-container>
</template>

<script>
import { userService } from "@/services";
import renderDate from "@/mixins/renderDate";
import setFiltersQueries from "@/mixins/setFilters&Queries";
import autocompleteListLazyLoading from "@/mixins/autocompleteListLazyLoading";

export default {
  name: "users-list",
  mixins: [renderDate, setFiltersQueries, autocompleteListLazyLoading],
  data() {
    return {
      pageCount: 0,
      totalPages: 1,
      loading: false,
      shortList: "",
      filtersObj: {
        userId: null,
        page: 1,
        size: 10
      },
      tableFilters: [] || "",
      tableData: []
    };
  },
  async created() {
    await this.$setFiltersFromQuery();
    await this.filtersSubmission(true);
    if (this.filtersObj.userId) {
      await this.getUserInfo();
    }
  },
  methods: {
    intersectUsernameList() {
      this.usernamesList.page++;
      this.usernamesList.moreItemsLoading = true;
      this.getAllAutocompleteItems(
        this.service,
        "usernamesList",
        "username",
        false
      );
    },
    resetFilters() {
      for (let key in this.filtersObj) {
        this.filtersObj[key] = null;
      }
      this.filtersObj.page = 1;
      this.filtersObj.size = 10;
      this.filtersSubmission();
    },
    async filtersSubmission(paginationButton) {
      await this.loadData(this.$setQueryFromFilters(paginationButton));
    },
    async loadData(tableFilters) {
      this.loading = true;
      await userService
        .getAllUsers(tableFilters)
        .then(response => {
          this.tableData = response.data.data.content;
          const tableDataLength = this.tableData.length;
          if (tableDataLength < 5 && tableDataLength > 0) {
            if (tableDataLength === 1) {
              this.shortList = "short-list-one-item";
            } else this.shortList = "short-list";
          } else this.shortList = "";
          this.totalPages = response.data.data.totalPages;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "List";
</style>
